// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"ac5e8724","669":"4dc80bb6","787":"62a01299"}[chunkId] + ".chunk.js";
};